import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConnectionToExternalBankKoModule } from '@modules/webauth-popup/pages/connection-to-external-bank-ko/connection-to-external-bank-ko.module';
import { SharedModule } from '@shared/shared.module';
import { ErrorModule } from '../error/error.module';
import { AccountsAnswerModule } from './pages/accounts-answer/accounts-answer.module';
import { BankChoiceModule } from './pages/bank-choice/bank-choice.module';
import { ConsentModule } from './pages/consent/consent.module';
import { LoginModule } from './pages/login/login.module';
import { NoneAccountsFoundModule } from './pages/none-accounts-found/none-accounts-found.module';
import { BankConnectionFailureRetryModule } from './pages/bank-connection-failure-retry/bank-connection-failure-retry.module';
import { ScaWaitingModule } from './pages/sca-waiting/sca-waiting.module';
import { SelectAccountsModule } from './pages/select-accounts/select-accounts.module';
import { WaitOnExternalBankLoginModule } from './pages/wait-on-external-bank-login/wait-on-external-bank-login.module';
import { ProcessComponent } from './process.component';

@NgModule({
  declarations: [ProcessComponent],
  imports: [
    CommonModule,
    ConsentModule,
    BankChoiceModule,
    LoginModule,
    ErrorModule,
    ScaWaitingModule,
    SelectAccountsModule,
    NoneAccountsFoundModule,
    AccountsAnswerModule,
    WaitOnExternalBankLoginModule,
    ConnectionToExternalBankKoModule,
    BankConnectionFailureRetryModule,
    SharedModule,
  ],
  exports: [ProcessComponent],
})
export class ProcessModule {}
